module.exports = __webpack_public_path__ + "static/media/free-branded-template.c01b6b3f.jpg";